import { render, staticRenderFns } from "./GlossaryBadObjectsEdit.vue?vue&type=template&id=6c30673e&"
import script from "./GlossaryBadObjectsEdit.vue?vue&type=script&lang=js&"
export * from "./GlossaryBadObjectsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports